import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Form, Select } from 'antd';
import { global } from '@/modules';
import { Langs } from '@/components';
import { AppType as TeamTypeProps } from '@/service/team/type/create';
import { APPTypeDatum } from '@/service/global/type/appType';

type propsType = {
  name?: string;
  disabled?: boolean;
  type?: 'team' | 'app';
};

const TEAM_TYPE_MAP: Record<`${TeamTypeProps}`, React.ReactNode> = {
  APP_TYPE_ALL: <Langs title="general_type" />,
  APP_TYPE_SELLER: <Langs title="tit_create_one_3" />,
  APP_TYPE_SUPPLIER: <Langs title="sp_application" />,
  APP_TYPE_UNSPECIFIED: <div>UNSPECIFIED</div>,
};

const APP_TYPE_MAP: Record<`${APPTypeDatum}`, React.ReactNode> = {
  TYPE_SELLER: <Langs title="sl_application" />,
  TYPE_SUPPLIER: <Langs title="sp_application" />,
  TYPE_UNSPECIFIED: <div>UNSPECIFIED</div>,
};

export const AppType = ({ name, disabled, type }: propsType) => {
  const appType = useSelector(global.selector.getType);
  const teamType = useSelector(global.selector.getTeamType);
  const { t } = useTranslation();
  console.log(appType, 'appType');
  const TypeAppLication = type === 'team' ? teamType! : appType!;

  return (
    <>
      <Form.Item
        label={<Langs title="app_type" />}
        name={name || 'type'}
        rules={[
          {
            required: true,
            message: <Langs title="select_application_type" />,
          },
        ]}
      >
        <Select placeholder={t('develop_prefix_Placeholder2') as string} disabled={disabled}>
          {TypeAppLication.map((items) => {
            return (
              <Select.Option value={items.data} key={items.id}>
                {type === 'team' ? TEAM_TYPE_MAP[items.data] : APP_TYPE_MAP[items.data]}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </>
  );
};
